import Network from '../network.js'

export default {
  getMeta(request) {
    return Network.get('/dashboard/meta', request, true)
  }
}
